import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Checkbox, Upload, Row, Col, Space, Button } from "antd";
import { observer } from "mobx-react";
import { articlesStore } from "../../store/content/article/ArticlesStore";
import "./ArticleDlg.scss";
import Storage from "@aws-amplify/storage";
import { v4 } from "uuid";
import { formatBytes } from "../../common/Utils";

export const ArticleDlg = observer(() => {
  const [form] = Form.useForm();

  const store = articlesStore;

  const [fileList, setFileList] = useState<any>([]);
  const [videoList, setVideoList] = useState<any>([]);

  const upImg = (key, file, img) => {
    console.log("upImg：", key, file, img);

    Storage.put(key, file, {})
      .then((res) => {
        console.log("upload file res", res);
        setFileList([
          {
            path: `public/${key}`,
            url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/public/${key}`,
            imageHeight: img.naturalHeight,
            imageWidth: img.naturalWidth,
            imageSize: formatBytes(file.size),
          },
        ]);
      })
      .catch((err) => {
        console.log("Error uploading file: ", err);
      });
  };

  const beforeUpload = (file) => {
    const index = file.name.lastIndexOf(".");
    const ext = file.name.substr(index + 1);
    const key = `${v4()}.${ext.toLowerCase()}`;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img: any = document.createElement("img");
      img.src = reader.result;
      img.onload = () => {
        if (file.size > 2 * 1024 * 1024) {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          if (context) {
            let rate = 0.2;
            const fileSizeKB = Math.floor(file.size / 1024);
            console.log("file size：", fileSizeKB, "kb");

            rate = Math.floor((3072 / fileSizeKB) * 10) / 30;
            let targetW = (canvas.width = img.width * rate);
            let targetH = (canvas.height = img.height * rate);
            context.clearRect(0, 0, targetW, targetH);
            context.drawImage(img, 0, 0, targetW, targetH);

            console.log("rate", rate);
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  let imgFile = new File([blob], file.name, { type: file.type });
                  upImg(key, imgFile, img);
                }
              },
              file.type,
              1
            );
          } else {
            upImg(key, file, img);
          }
        } else {
          upImg(key, file, img);
        }
      };
    };

    return false;
  };

  const beforeVideoUpload = (file) => {
    const index = file.name.lastIndexOf(".");
    const ext = file.name.substr(index + 1);
    const key = `${v4()}.${ext}`;

    console.log("video", file, key);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img: any = document.createElement("video");
      img.src = reader.result;
      img.addEventListener("loadedmetadata", () => {
        console.log("video", img.videoHeight);
        Storage.put(key, file, {})
          .then((res) => {
            console.log("upload file res", res);
            setVideoList([
              {
                path: `public/${key}`,
                url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/public/${key}`,
                imageHeight: img.videoHeight,
                imageWidth: img.videoWidth,
                imageSize: formatBytes(file.size),
              },
            ]);
          })
          .catch((err) => {
            console.log("Error uploading file: ", err);
          });
      });
    };

    return false;
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onVideoPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const ok = () => {
    form.validateFields().then((values) => {
      console.log("values", values, fileList);
      store.editStore.save({
        ...values,
        images: fileList.map(({ path, imageWidth, imageHeight, imageSize }) => ({
          url: path,
          imageWidth,
          imageHeight,
          imageSize,
        })),
        videos: videoList.map(({ path, imageWidth, imageHeight, imageSize }) => ({
          url: path,
          imageWidth,
          imageHeight,
          imageSize,
        })),
      });
    });
  };

  useEffect(() => {
    if (store.editStore.model) {
      form.setFieldsValue(store.editStore.model);
      setFileList(
        (store.editStore.model.images || []).map((img) => ({
          path: img.url,
          url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${img.url}`,
          imageWidth: img.imageWidth,
          imageHeight: img.imageHeight,
          imageSize: img.imageSize,
        }))
      );
      setVideoList(
        (store.editStore.model.videos || []).map((img) => ({
          path: img.url,
          url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${img.url}`,
          imageWidth: img.imageWidth,
          imageHeight: img.imageHeight,
          imageSize: img.imageSize,
        }))
      );
    }
  }, [store.editStore.model]);

  return (
    <Modal
      title="Article"
      visible={true}
      confirmLoading={store.editStore.saving}
      maskClosable={false}
      onOk={ok}
      onCancel={() => store.editStore.close()}
      width="80%"
      className="article-dlg"
    >
      <Form form={form} labelCol={{ span: 6 }} initialValues={{ retired: false }} wrapperCol={{ span: 18 }}>
        <Row gutter={48}>
          <Col span={10}>
            <Form.Item
              name="type"
              label="Content Type"
              rules={[{ required: true, message: "Please select content type" }]}
            >
              <Select style={{ width: "100%" }} placeholder="Please select">
                {store.editStore.types.map((p) => (
                  <Select.Option key={p} value={p}>
                    {p}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Article Name"
              name="title"
              rules={[{ required: true, message: "Please input article name" }]}
            >
              <Input maxLength={150} placeholder="Enter article name" />
            </Form.Item>
            <Form.Item label="Image">
              <Upload
                accept="image/*"
                listType="picture-card"
                fileList={fileList}
                onPreview={onPreview}
                beforeUpload={beforeUpload}
                onRemove={() => setFileList([])}
              >
                {fileList.length < 1 && "+ Upload"}
              </Upload>
            </Form.Item>
            <Form.Item label="Video">
              {videoList.length > 0 && (
                <Space direction="vertical">
                  <video width={300} style={{ maxHeight: 300 }} controls src={videoList[0].url}></video>
                  <Button danger onClick={() => setVideoList([])}>
                    Delete
                  </Button>
                </Space>
              )}
              {videoList.length === 0 && (
                <Upload
                  accept="video/*"
                  listType="picture-card"
                  fileList={videoList}
                  onPreview={onVideoPreview}
                  beforeUpload={beforeVideoUpload}
                  onRemove={() => setVideoList([])}
                >
                  {videoList.length < 1 && "+ Upload"}
                </Upload>
              )}
            </Form.Item>
            <Form.Item label="Retired" name="retired" valuePropName="checked">
              <Checkbox></Checkbox>
            </Form.Item>
            <Form.Item label="Summary" name="description">
              <Input.TextArea rows={6} autoSize style={{ minHeight: 100 }} />
            </Form.Item>
          </Col>
          <Col span={14}>
            <Form.Item
              label="Content"
              name="content"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              extra="Subtitle Format: <<subtitle>>"
              rules={[{ required: true, message: "Please inpute content", whitespace: true }]}
            >
              <Input.TextArea rows={6} autoSize style={{ minHeight: 600 }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
});
